// extracted by mini-css-extract-plugin
export default {"Controls":"Controls_Controls__D3ypm"};